// Scopes ELT requests when authorizing HubSpot.
export const HUBSPOT_OAUTH_SCOPES = Object.freeze([
  'oauth',
  'forms',
  'automation',
  'content',
  'crm.lists.read',
  'crm.objects.contacts.read',
  'crm.schemas.contacts.read',
  'crm.objects.companies.read',
  'crm.objects.deals.read',
  'crm.schemas.companies.read',
  'crm.schemas.deals.read',
  'crm.objects.owners.read',
  'crm.objects.custom.read',
  'crm.schemas.custom.read',
]);

// The vue-authenticate provider options that put HUBSPOT_OAUTH_SCOPES in the install URL (ELT-640).
// HubSpot silently drops a scope its app marks Optional if it's sent in `scope`, so those go in `optional_scope`.
// Which scopes are optional is set per app, so `optionalScopes` (comma or space separated) is configured alongside
// the app's client ID. Empty keeps every scope in `scope`; scopes ELT doesn't request, and `oauth` (which HubSpot
// requires in `scope`), are ignored.
export default function getHubSpotOAuthScopeParams(optionalScopes = '') {
  const configured = new Set(optionalScopes.split(/[\s,]+/).filter(Boolean));
  configured.delete('oauth');
  const optional = HUBSPOT_OAUTH_SCOPES.filter((scope) =>
    configured.has(scope),
  );
  if (!optional.length) {
    return {
      scope: HUBSPOT_OAUTH_SCOPES,
      requiredUrlParams: ['scope', 'state'],
    };
  }
  return {
    scope: HUBSPOT_OAUTH_SCOPES.filter((scope) => !configured.has(scope)),
    // vue-authenticate only joins `scope` arrays, so this is sent pre-joined with the same delimiter.
    optionalScope: optional.join('%20'),
    requiredUrlParams: ['scope', 'optional_scope', 'state'],
  };
}
